var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgPlayCircle = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none"
}, props), /*#__PURE__*/React.createElement("mask", {
  id: "play_circle_svg__a",
  width: 16,
  height: 16,
  x: 0,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#D9D9D9",
  d: "M0 0h16v16H0z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#play_circle_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "m6.332 10.999 4.667-3-4.667-3v6Zm1.667 3.666a6.492 6.492 0 0 1-2.6-.525 6.732 6.732 0 0 1-2.117-1.425A6.733 6.733 0 0 1 1.857 10.6a6.492 6.492 0 0 1-.525-2.6c0-.923.175-1.79.525-2.6a6.732 6.732 0 0 1 1.425-2.117c.6-.6 1.306-1.075 2.117-1.425a6.492 6.492 0 0 1 2.6-.525c.922 0 1.789.175 2.6.525.81.35 1.516.825 2.116 1.425.6.6 1.075 1.306 1.425 2.117.35.81.525 1.677.525 2.6 0 .922-.175 1.789-.525 2.6a6.733 6.733 0 0 1-1.425 2.116c-.6.6-1.305 1.075-2.116 1.425a6.492 6.492 0 0 1-2.6.525Z"
}))));
export default SvgPlayCircle;